export const ACTIVE_WINDOW_DAYS = 14;

export function getNextMonotonicIso(existingIso, candidateIso) {
  const existing = String(existingIso || "");
  const candidate = String(candidateIso || "");
  if (!existing) return candidate;
  if (!candidate) return existing;
  return existing > candidate ? existing : candidate;
}

export function isWithinDays(isoString, nowMs = Date.now(), days = 14) {
  const ts = new Date(isoString).getTime();
  if (Number.isNaN(ts)) return false;
  return ts >= nowMs - days * 24 * 60 * 60 * 1000;
}

export function isOlderThanDays(isoString, nowMs = Date.now(), days = 14) {
  const ts = new Date(isoString).getTime();
  if (Number.isNaN(ts)) return false;
  return ts < nowMs - days * 24 * 60 * 60 * 1000;
}

export function isPendingRequestExpired(row, nowMs = Date.now(), days = ACTIVE_WINDOW_DAYS) {
  const status = row?.status || "accepted";
  if (status !== "pending") return false;
  const requestCreatedAt =
    row?.request_created_at ||
    row?.requestCreatedAt ||
    row?.createdAt ||
    row?.SK ||
    "";
  return isOlderThanDays(requestCreatedAt, nowMs, days);
}

export function isActiveListConversation(row, mySenderId, nowMs = Date.now()) {
  const status = row?.status || "accepted";
  const lastUpdatedAt = row?.SK;

  const allowedByStatus = status === "accepted" || status === "pending";
  if (!allowedByStatus) return false;
  if (status === "pending" && isPendingRequestExpired(row, nowMs, ACTIVE_WINDOW_DAYS)) {
    return false;
  }
  return isWithinDays(lastUpdatedAt, nowMs, ACTIVE_WINDOW_DAYS);
}

export function isPastListConversation(row, nowMs = Date.now()) {
  const status = row?.status || "accepted";
  if (status !== "accepted") return false;
  return isOlderThanDays(row?.SK, nowMs, ACTIVE_WINDOW_DAYS);
}

export function shouldShowPingPending(row, mySenderId, nowMs = Date.now()) {
  const status = row?.status || "accepted";
  const isInitiatedByMe = row?.initiated_by === mySenderId;
  return (
    status === "pending" &&
    !isInitiatedByMe &&
    !isPendingRequestExpired(row, nowMs, ACTIVE_WINDOW_DAYS)
  );
}

export function shouldShowPingAcceptedInitiatedByMe(
  row,
  mySenderId,
  nowMs = Date.now(),
  hours = 24
) {
  const status = row?.status || "accepted";
  const isInitiatedByMe = row?.initiated_by === mySenderId;
  if (!(status === "accepted" && isInitiatedByMe)) return false;

  const ts = new Date(row?.SK).getTime();
  if (Number.isNaN(ts)) return false;
  return nowMs - ts <= hours * 60 * 60 * 1000;
}

export function hasPingUnread(rows, mySenderId, lastSeenPingTimestamp) {
  const marker = String(lastSeenPingTimestamp || "");
  return (rows || []).some((row) => {
    const activityAt = String(row?.updatedAt || row?.SK || "");
    const pendingForMe = shouldShowPingPending(row, mySenderId);
    const acceptedByCounterpart = shouldShowPingAcceptedInitiatedByMe(
      { ...row, SK: activityAt },
      mySenderId
    );
    return (pendingForMe || acceptedByCounterpart) && activityAt > marker;
  });
}

export function hasUnreadMessageSk(messageSk, lastSeenActiveTimestamp) {
  const marker = String(lastSeenActiveTimestamp || "");
  if (!marker) return true;
  return String(messageSk || "") > marker;
}
